<template>
  <div>
    <div>
      <p class="mb-8 mt-4 text-left text-dark-gray sm:mt-2">
        Please provide the name of your Insurance Agency for your Cargo
        Insurance policy.
      </p>
      <p class="mb-2 border-b-2 border-light-gray text-left text-body-color">
        Policy Details
      </p>

      <radio-button
        item="Same agency as auto liability"
        :active="data.same_agency"
        :handle-select="handleClick"
        name="same_agency"
      />

      <div class="my-6">
        <p class="mb-2 border-b-2 border-light-gray text-left text-body-color">
          {{
            data.cargo_insurance?.agency?.name
              ? 'Insurance Agency Details'
              : 'Insurance Agency (Required)'
          }}
        </p>

        <div v-if="!data?.same_agency">
          <insurance-form
            name="cargo_insurance"
            :data="data"
            :step-name="stepName"
            source-step-name="Insurance-2"
            :update-field="updateField"
          />
        </div>

        <div
          v-if="data.cargo_insurance?.agency?.name && data?.same_agency"
          class="mt-4 md:flex md:flex-row"
        >
          <div class="mb-4 md:mr-16">
            <p
              class="text-left text-2xs font-bold uppercase text-gray-over-dark"
            >
              Agency Name
            </p>
            <p class="mt-1 text-left text-dark-gray">
              {{ data.cargo_insurance.agency.name }}
            </p>
          </div>
          <div class="mb-4 md:mr-16">
            <p
              class="text-left text-2xs font-bold uppercase text-gray-over-dark"
            >
              Phone #
            </p>
            <p
              v-if="
                data.cargo_insurance?.agency
                  ?.input_phone_number_with_country_code ||
                data.cargo_insurance?.agency?.phone_number
              "
              class="mt-1 text-left text-dark-gray"
            >
              {{ formatE164Number }}
            </p>
          </div>
          <div class="mb-4">
            <p
              class="text-left text-2xs font-bold uppercase text-gray-over-dark"
            >
              email
            </p>
            <p
              v-if="data.cargo_insurance?.agency?.email"
              class="mt-1 text-left text-dark-gray"
            >
              {{ data.cargo_insurance?.agency?.email }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <form-navigation-buttons
      v-if="!isNavigationDisabled"
      :enabled="!isNavigationDisabled"
      :component-identifier="componentIdentifier"
      :buttons-to-display="buttonsToDisplay"
      :is-button-disabled="isButtonDisabled"
      @next="handleNext"
      @back="handleBack"
      @edit="handleEdit"
      @exit-modal="emitExitModal"
    />
  </div>
</template>

<script>
import FormNavigationButtons from '@/components/FormNavigationButtons.vue';
import { useFormRouter } from '@/composables/formRouter';
import { useStore } from 'vuex';
import { computed } from 'vue';
import RadioButton from '@/components/RadioButton.vue';
import { formatPhone } from '@/common/validators';
import InsuranceForm from '@/components/InsuranceForm.vue';
import { formatE164 } from '@/common/validators.js';

export default {
  name: 'InsuranceStepTwo',
  components: {
    RadioButton,
    InsuranceForm,
    FormNavigationButtons,
  },
  props: {
    data: Object,
    updateField: Function,
    nextStep: Function,
    formPosition: Number,
    title: String,
    stepName: String,
  },
  setup(_, { emit }) {
    const store = useStore();
    const componentIdentifier = 'Insurance-2';
    const formRouter = useFormRouter(componentIdentifier);
    const isNavigationDisabled = computed(() => formRouter.isDisabled.value);
    const firstTime = computed(
      () =>
        store.state.firstTime?.[
          formRouter.componentStep.value?.firstTimeIdentifier
        ]
    );
    const buttonsToDisplay = computed(() => {
      if (firstTime.value) return 'continue-save';
      return 'continue-edit';
    });
    const isButtonDisabled = false;

    const handleNext = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleNext' called"
      );
      if (isNavigationDisabled.value)
        return store.commit(
          'addFormDebugMessage',
          'ERROR: ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );
      formRouter.moveToNextStep();
    };

    const handleBack = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleBack' called"
      );
      if (isNavigationDisabled.value)
        return console.log(
          'ERROR: ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );
      formRouter.moveToPreviousStep();
    };

    const handleEdit = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleEdit' called"
      );
      if (isNavigationDisabled.value)
        return console.log(
          'ERROR: ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );
      formRouter.editActiveStep();
    };

    const emitExitModal = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'emitExitModal' called"
      );
      emit('exit-modal');
    };

    return {
      componentIdentifier,
      handleNext,
      handleBack,
      handleEdit,
      buttonsToDisplay,
      isButtonDisabled,
      isNavigationDisabled,
      firstTime,
      emitExitModal,
    };
  },
  data() {
    return {
      items: [],
      agencytt: {
        name: "GOOD'S INSURANCE AGENCY INC",
        street1: '20 TRINITY DRIVE Suite 100',
        city: 'LEOLA',
        state: 'PA',
        postal_code: '17540',
      },
    };
  },
  computed: {
    phoneFormatted() {
      if (this.data.auto_liability_insurance.agency?.phone) {
        return formatPhone(this.data.auto_liability_insurance.agency.phone);
      } else {
        return '-';
      }
    },
    formatE164Number() {
      if (
        this.data.cargo_insurance?.agency?.input_phone_number_with_country_code
      ) {
        return formatE164(
          this.data.cargo_insurance.agency.input_phone_number_with_country_code
        );
      } else {
        return this.data.cargo_insurance?.agency?.phone_number;
      }
    },
  },
  watch: {
    stepName: function (val) {
      if (val === 'Insurance-2') {
        this.agency = {
          name: '',
          phone_number: '',
          email: '',
        };
        this.updateField('same_agency', true);
        const combinedCargo = {
          ...this.data.cargo_insurance,
          agency: this.data.auto_liability_insurance.agency,
        };
        this.updateField('cargo_insurance', combinedCargo);

        if (!this.data.same_agency) {
          this.$store.commit('toggleDisabledButton', {
            bool: true,
            source: 'InsuranceStepTwo #1',
          });
        } else {
          this.$store.commit('toggleDisabledButton', {
            bool: false,
            source: 'InsuranceStepTwo #1',
          });
        }
      }
    },
  },
  methods: {
    handleClick() {
      this.updateField('same_agency', !this.data.same_agency);
      if (this.data.same_agency) {
        this.$store.commit('toggleDisabledButton', {
          bool: false,
          source: 'InsuranceStepTwo #3',
        });

        const combinedCargo = {
          ...this.data.cargo_insurance,
          agency: this.data.auto_liability_insurance.agency,
        };
        this.updateField('cargo_insurance', combinedCargo);
      } else {
        this.$store.commit('firstTime/updateStepFirstTime', {
          step: 'Insurance',
          value: true,
        });
        if (
          !this.agency.name ||
          !this.agency.phone_number ||
          !this.agency.email
        ) {
          this.$store.commit('toggleDisabledButton', {
            bool: true,
            source: 'InsuranceStepTwo #4',
          });
        }

        const filteredCargo = {
          ...this.data.cargo_insurance,
          agency: {},
        };
        this.updateField('cargo_insurance', filteredCargo);
      }
    },
  },
};
</script>
